<template>
    <div component="ActorsHeader">
        <div class="filter">
            <div class="select-actors cell">
                <v-autocomplete
                    v-model="filter.actor"
                    :items="getAllActors"
                    class="autocomplete select"
                    clearable
                    dense
                    filled
                    hide-details
                    item-text="meno_priezvisko"
                    item-value="id"
                    label="chose an actor"
                    rounded
                    solo
                    @change="onChange"
                    :filter="customFilter"
                >
                </v-autocomplete>
            </div>

            <div class="radio-input">
                <label class="radio">
                    <input type="radio" name="state" value="1" v-model="filter.status" @change="onChange" />
                    <span></span>
                    Active
                </label>
                <label class="radio">
                    <input type="radio" name="state" value="0" v-model="filter.status" @change="onChange" />
                    <span></span>
                    Inactive
                </label>
                <label class="radio">
                    <input type="radio" name="state" value="2" v-model="filter.status" @change="onChange" />
                    <span></span>
                    Deleted
                </label>
            </div>

            <div class="action cell">
                <btn icon="add_circle" text="ADD ACTOR" color="base" @click="addActor"></btn>
            </div>
        </div>

        <div class="filter">
            <v-text-field
                v-model="filter.search"
                v-on:keyup.enter="onChange"
                v-on:click:clear="clear"
                class="search"
                clearable
                hide-details
                label="Search"
            />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Autocomplete from '@/components/.global/Autocomplete.vue';
import lodash from 'lodash';
import { get, set } from 'local-storage';

export const ACTORS_STORAGE_KEY = 'vc.actors';

export default {
    name: 'ActorsHeader',

    components: {
        Autocomplete,
    },

    data: () => ({
        filter: {},
    }),

    async created() {
        let actorParams = get(ACTORS_STORAGE_KEY);

        const query = this.transformQuery(this.$route.query);

        if (!lodash.isEqual(query, actorParams) && !lodash.isEmpty(query)) {
            actorParams = query;
            set(ACTORS_STORAGE_KEY, actorParams);
        }

        if (lodash.isObject(actorParams)) {
            this.filter = actorParams;
        }

        if (!lodash.isEmpty(actorParams)) {
            await this.$router.push({ query: actorParams }).catch(() => {});
        }

        await this.loadAllActors();
        this.$emit('onChange', this.filter);
    },

    methods: {
        ...mapActions(['loadAllActors']),

        customFilter(item, queryText) {
            const normalizeText = (text) =>
                text
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .toLowerCase();

            const queryParts = normalizeText(queryText).split(' ');
            const normalizedItemText = normalizeText(item.meno_priezvisko);
            return queryParts.every((part) => normalizedItemText.includes(part));
        },

        transformQuery(query) {
            if (query.actor) {
                query.actor = parseInt(query.actor);
            }

            return query;
        },

        async clear() {
            this.filter.search = '';
            await this.onChange();
        },

        async onChange() {
            set(ACTORS_STORAGE_KEY, this.filter);

            await this.$router.push({ query: this.filter }).catch(() => {});
            this.$emit('onChange', this.filter);
        },

        addActor() {
            this.$router.push({ path: '/actors/detail' }).catch(() => {});
        },
    },

    computed: {
        ...mapGetters(['getAllActors']),
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ActorsHeader'] {
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    .filter {
        display: flex;
        align-items: flex-start;
        padding: 10px 0;
        width: 100%;

        .search /deep/ .v-input__slot {
            padding-left: 15px !important;
        }
    }

    .select-actors {
        flex: 0.7;
        max-width: 500px;
    }

    .name {
        flex: 0.5;
        padding: 0 20px;

        h3 {
            margin-top: 0;
        }
    }

    .action {
        margin-left: auto;
    }

    .input.select {
        max-width: 250px;
        margin-right: 1rem;
    }

    .autocomplete.select {
        max-width: 300px;
        margin-right: 1rem;
    }

    .radio-input {
        flex-direction: row;
        gap: 20px;

        /deep/ span {
            margin-left: 0;
            margin-right: 5px;
        }
    }
}
</style>
